import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTabs,{attrs:{"color":"primary"}},[_c(VTab,[_vm._v("General")]),_c(VTabItem,{key:("offer-aggregated-LP-" + (this.item.data.id) + "-general")},[_c(VRow,{staticClass:"text-center aggregatedOfferGrid"},[_c(VDataTable,{staticClass:"elevation-1 items-size-45",attrs:{"headers":_vm.offersAggregatedHeader,"items":this.getOffersAggregated,"items-per-page":10},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"td_title"},[_c('a',{staticClass:"entity-link"},[_vm._v(_vm._s(item.name))])])]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }